import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { EsignatureProvider } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EsignatureWebhookEventViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  providerOptions: { id: string; displayId: string }[];
  provider: EsignatureProvider;
  externalEventIdValue?: { displayId: string; id: string } | null;
  externalEventId: string;
  eventTypeValue?: { displayId: string; id: string } | null;
  eventType: string;
  documentExternalIdValue?: { displayId: string; id: string } | null;
  documentExternalId: string;
  processedAtValue?: { displayId: string; id: string } | null;
  processedAt: Date | null;
  errorValue?: { displayId: string; id: string } | null;
  error: string;
};

export const EsignatureWebhookEventViewForm: React.FC<EsignatureWebhookEventViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      providerOptions = [],
      provider = "" as EsignatureProvider,
      externalEventId = "",
      eventType = "",
      documentExternalId = "",
      processedAt = null,
      error = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupEsignatureWebhookEventLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    provider
                      ? providerOptions.find(
                          (o: { id: string }) => o.id === provider
                        )?.displayId || provider
                      : ""
                  }
                  label={langStore.EsignatureWebhookEventProviderLabel}
                />
                <ShowMultiLine
                  value={externalEventId}
                  label={langStore.EsignatureWebhookEventExternalEventIdLabel}
                />
                <ShowMultiLine
                  value={eventType}
                  label={langStore.EsignatureWebhookEventEventTypeLabel}
                />
                <ShowMultiLine
                  value={documentExternalId}
                  label={
                    langStore.EsignatureWebhookEventDocumentExternalIdLabel
                  }
                />

                <ShowDateTime
                  value={processedAt}
                  label={langStore.EsignatureWebhookEventProcessedAtLabel}
                />
                <ShowMultiLine
                  value={error}
                  label={langStore.EsignatureWebhookEventErrorLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
